import _ from 'lodash';

import {Lang} from 'contexts/LangContext';
import {NavigationFooterConfig, ShortConfigParams} from 'units/navigation/models';
import getConfigItems from '../constants';

export function getFooterConfig(params: ShortConfigParams): NavigationFooterConfig {
    const {locale, i18n, env} = params;
    const {lang} = locale;
    const {common, features, community, social, mobileStores} = getConfigItems(locale, i18n, env);

    const servicesAndOther = [
        {
            title: common.servicesAndTools.title,
            items: [
                common.services,
                common.prices,
                common.docs,
                common.solutions,
                common.marketplace,
                common.statusboard,
            ],
        },
    ];

    const yandexCloudGroup = [
        {
            title: common.yandexCloud.title,
            items: [common.about, common.job, common.brandbook],
        },
    ];
    const contactsGroup = [
        {
            title: common.contacts.title,
            items: [common.contactEmail, features.items['docs/support/overview'], common.sales],
        },
    ];

    const ruColumns = [
        servicesAndOther,
        [
            {
                title: features.title,
                items: [
                    features.items.security,
                    features.items['for-business'],
                    features.items['for-education-and-science'],
                    features.items.cases,
                    features.boost,
                    features.partnerPropgram,
                    features.items['partners/catalogue'],
                ],
            },
        ],
        [
            {
                title: community.title,
                items: [
                    community.items.events,
                    community.items['content-program'],
                    community.items.blog,
                    community.items.features,
                ],
            },
        ],
        [...yandexCloudGroup, ...contactsGroup],
    ];
    const enColumns = [
        servicesAndOther,
        [
            {
                title: features.title,
                items: [features.items.security, features.items.cases, features.boost],
            },
        ],
        yandexCloudGroup,
        contactsGroup,
    ];

    return {
        columns: lang === Lang.Ru ? ruColumns : enColumns,
        social:
            lang === Lang.Ru
                ? [social.telegram, social.vk, social.youtube, social.github, social.rss]
                : [social.facebook, social.github],
        footer: [common.confidential, common.terms],
        mobileStores,
    };
}

export default _.memoize(getFooterConfig);
